import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
    bbActualStringOfHyperlinkedVulnsFromArray, bbActualStringOfVulnsFromTarget,
    bbDoesCustomerHaveAccessToModule, bbDoesUserHaveAccessToModule,
    bbGetModulePropertyFromIdOrName,
    BBModuleIcon,
    bbShortenString, bbSortIpCompare,
    bbStringOfHyperlinkedVulnsFromArray,
    bbStringOfVulnsFromTarget,
    filterObject,
    mapObject
} from "../../../../util/bbHelpers";
import {fetchCustomers, fetchTargets} from "../../../../actions";
import PropTypes from "prop-types";
import Tooltip from "@material-ui/core/Tooltip";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import SystemTargetToggleSwitch from "../../controllers/SystemTargetToggleSwitch";
import BBDataTable from "../../tables/BBDataTable";
import {renderCellExpand} from "../../tables/DataGridRenderCellExpand";
import {GpsNotFixedSharp} from "@material-ui/icons";

// const useStyles = makeStyles((theme) => ({
//     button: {
//         margin: theme.spacing(1),
//     },
// }));

const TableContainer = (props) => {

    const {customerId} = props;


  /**************************/
  /*Setup State and Dispatch*/
  /**************************/
  const {customers, loadingCustomers, customerInView, loadingTargets, loadingTargetsError, metaTargets} = useSelector(({customer}) => customer);
  // const {authUser} = useSelector(({auth}) => auth);
  const dispatch = useDispatch();
  //select the customer from the store if it exists, based on the props customerId
  const customer = customers ? customers[customerId] ? customers[customerId] : null : null;
  //from the customer, pull the target data if it exists
  const targets = customer ? customer.targets ? customer.targets : null : null;
  const vulnerableActiveTargets = targets ? filterObject(targets, (_, target) => target.Vulnerabilities && (Array.isArray(target.Vulnerabilities) ? target.Vulnerabilities.length > 0 : true) && target.IsActive !== false) : null;
  const totalNumVulnTargets = (metaTargets && metaTargets[customer.CustomerId] && metaTargets[customer.CustomerId].targets_with_vulns) ? metaTargets[customer.CustomerId].targets_with_vulns : null;
    // const targetsBatchSize = (metaTargets && metaTargets[customer.CustomerId] && metaTargets[customer.CustomerId].page_size) ? metaTargets[customer.CustomerId].page_size : 10;

  useEffect(() => {
    // console.group("VulnTargets Table for customerId: ", customerId, " customer: ", customer, " targets: ", targets)
    // console.log("VulnTargets here is the customers in the store", customers)
    if (customers == null && !loadingCustomers) {
      // console.log("Customers is empty, fetching.")
      dispatch(fetchCustomers());
    }
      if (customer === null) {
          // console.log("No customer with customerId", customerId," was found.")
      } else if (customer && targets === null && !loadingTargets) {
          // console.log("targets is empty, fetching targets for customerId = ", customer.CustomerId);
          dispatch(fetchTargets({
              customerId: customer.CustomerId
          }));
      }
    // console.groupEnd()
  }, [customerId, customers, customerInView, targets, dispatch, loadingTargets, loadingCustomers, customer]);

  /**************************/
  /*End Setup State and Dispatch*/
  /**************************/

    const title = <span className={"tourStepVulnerableSystemTargetsTable"}>
        Vulnerable System Targets <Tooltip title={"Vulnerable System Targets have detectable Common Vulnerabilities and Exposures.  These targets give attackers even more options to achieve a breach."}>
            <InfoSharpIcon style={{fontSize: "smaller"}} className={``}/>
        </Tooltip>
    </span>;

  const userTableHeadings = [

      // { field: 'id', headerName: 'ID', hide: true, flex : 2, sortable: true, type: 'string', },
      { field: 'scope',
          renderHeader: (params) => <Tooltip title={"Target Scope"}><span><GpsNotFixedSharp style={{fontSize:"17px"}}/></span></Tooltip>,
          headerName: 'Scope', hide: false, sortable: true, type: 'string', width: 68,
          renderCell: (params) => (
              <SystemTargetToggleSwitch
                  customerId={params.row.customerId}
                  targetId={params.row.id}
                  targetProperty={"OutOfScope"}
              />
          ),
      },
      { field: 'ipAddress', headerName: 'IP', hide: false, sortable: true, type: 'string', width : 150, renderCell: (params) => (<code>{params.value}</code>),
          sortComparator: (v1, v2, param1, param2) => {
              try{
                  // console.log("IP column sort params", param1, param2);
                  return bbSortIpCompare(param1.value, param2.value);
              } catch(e) {
                  console.warn(e);
                  return false;
              }
          }
      },
      { field: 'domain', headerName: 'Domain', hide: false, sortable: true, type: 'string', flex : 2.5,renderCell: (params) => {
              if (params.row.domainTooltip) {
                  // return <Tooltip title={`Fully Qualified Domain Names: ${params.value}`}>
                  //     <code>
                  //         {params.value}
                  //     </code>
                  // </Tooltip>
                  return <small><code>
                          {params.value}
                      </code></small>
              } else {
                  return params.value
              }

          }},
      { field: 'os', headerName: 'OS', sortable: true, type: 'string', width: 75, renderCell: (params) => (
              <Tooltip title={`Target Operating System: ${params.value} | ${params.row.osDetailsDescription}`}>
                    <span>
                        {(params.row.osDetails && params.row.osDetailsLogo) && <img style={{height: 18}} src={params.row.osDetailsLogo} alt={`${bbShortenString(params.value, 25, true)}`} />}
                        {(!params.row.osDetails || !params.row.osDetailsLogo) && params.value}
                    </span>
              </Tooltip>
          )},
      { field: 'stringOfVulnerabilitiesForCSVExport', headerName: 'Vulnerabilities', hide: false, sortable: true, type: 'string', flex : 3, renderCell: (params) => (
              renderCellExpand(params, params.row.vulnerabilities)
          )},

  ];

    //peel the state data into a form the dataTable can read
  const tableData = vulnerableActiveTargets ? mapObject(vulnerableActiveTargets, (key, target) => {
    return (
        {
            customerId: customer.CustomerId,
            id: key,
            scope : target.OutOfScope !== "1" ? "In Scope" : "Out of Scope",
            ipAddress: target.IpAddress,
            domain: target.Fqdn
                ? Array.isArray(target.Fqdn)
                    ? target.Fqdn.length > 0
                        ? target.Fqdn.join(", ")
                        : "None detected"
                    : target.Fqdn
                : "None detected",
            domainTooltip: target.Fqdn
                ? Array.isArray(target.Fqdn)
                    ? target.Fqdn.length > 0
                        ? true
                        : false
                    : true
                : false,
            os: target.OsDetails.Name,
            osDetailsLogo: target.OsDetails.Logo,
            osDetailsDescription: target.OsDetails.Description,
            osDetails: target.OsDetails,
            vulnerabilities: target.Vulnerabilities
                ? Array.isArray(target.Vulnerabilities)
                    ? target.Vulnerabilities.length > 0
                        ? bbStringOfHyperlinkedVulnsFromArray(target.Vulnerabilities, "targetsTable")
                        : "None detected"
                    : typeof target.Vulnerabilities === "string"
                        ? bbStringOfVulnsFromTarget(target)
                        : target.Vulnerabilities
                : "None detected",
            stringOfVulnerabilitiesForCSVExport: target.Vulnerabilities
                ? Array.isArray(target.Vulnerabilities)
                    ? target.Vulnerabilities.length > 0
                        ? bbActualStringOfHyperlinkedVulnsFromArray(target.Vulnerabilities)
                        : ""
                    : typeof target.Vulnerabilities === "string"
                        ? bbActualStringOfVulnsFromTarget(target)
                        : ""
                : "None detected",
        }
    )
  }) : null;


    const tableDataAsArray = () => {
        // console.log("Creating humansTableData as array from humanTableData ", tableData);
        let arr=[];
        for (let ob in tableData) {
            // console.log("ob is ", tableData[ob])
            arr.push(tableData[ob]);
        }
        // console.log("resulting array ", arr);
        return arr;
    }

    return (
        <div >
            {((vulnerableActiveTargets || totalNumVulnTargets === 0) && !loadingTargetsError) &&
            <BBDataTable
                columns={userTableHeadings}
                rows={ tableDataAsArray()}
                totalRows={totalNumVulnTargets}
                progressValue={vulnerableActiveTargets ? Object.keys(vulnerableActiveTargets).length / totalNumVulnTargets * 100 : 0}
                bufferValue={vulnerableActiveTargets ? (Object.keys(vulnerableActiveTargets).length +1) / totalNumVulnTargets * 100 : 0}
                title={title}
                loading = {false}
                rowsPerPageOptions = {[5, 10, 25, 50, 100]}
                defaultPageSize={5}
                enableExport
                requiresModule={"monitor"}
                customer={customer}
                topRightElement={<BBModuleIcon includeTooltip module={bbGetModulePropertyFromIdOrName("monitor", "id")} isActive={bbDoesCustomerHaveAccessToModule(customer, "monitor")} iconSize={"40px"}/>}
                defaultSortModel = {[
                    {
                        field: 'domain',
                        sort: 'asc',
                    }
                ]}
            />
            }
            {!((vulnerableActiveTargets || totalNumVulnTargets === 0) && !loadingTargetsError) &&
            <BBDataTable
                columns={userTableHeadings}
                rows={[]}
                totalRows={totalNumVulnTargets}
                title={title}
                loading = {true}
                progressValue={0}
                bufferValue={0}
                numSkeletonRows={3}
                rowsPerPageOptions = {[5, 10, 25, 50, 100]}
                defaultPageSize={5}
            />
            }

        </div>
    );

  // if ((vulnerableActiveTargets || totalNumVulnTargets === 0) && !loadingTargetsError) {
  //   // console.log("VulnTargetsTable loading is finished here is the customers in the store", customers, "and table data", tableDataAsArray(), " and vulnerableTargets is: ", vulnerableTargets)
  //   return (
  //       <div  >
  //           <ArrayDataTable tableData={tableDataAsArray()} columnHeaders={userTableHeadings} overrideRowsPerPage = {targetsBatchSize} title={title} maxRecordsDisplayOverride = {totalNumVulnTargets}/>
  //       </div>
  //   );
  // } else if (loadingTargets || loadingCustomers) {
  //   return (
  //       <div className={""} >
  //           <ArrayDataTable tableData={null} columnHeaders={userTableHeadings} overrideRowsPerPage = {targetsBatchSize} title={title} loading={true} numSkeletonRows={2}/>
  //       </div>
  //   );
  //
  // } else {
  //   return (
  //       <div className={""} >
  //           <ArrayDataTable tableData={null} columnHeaders={userTableHeadings} overrideRowsPerPage = {targetsBatchSize} title={title} loading={true} numSkeletonRows={2}/>
  //       </div>
  //
  //   );
  // }


}
TableContainer.propTypes = {
    customerId: PropTypes.string,
};

export default TableContainer